import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import { Button } from "react-bootstrap";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import ListFilters from "components/sales/ListFilters/ListFilters";
import TableSection from "components/sales/tableSection/tableSection";

const ScoreBySenior = ({
  match,
  fetchSelfScorecardBySenior,
  getUserScoreBySenior = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [listData, setListData] = useState([]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const Headers = [
    "Site ID",
    "Meeting Date",
    "Subject",
    "Senior Rating",
    "Senior Remark",
    "Rating Date",
    "Rated By"
  ];
  

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await fetchSelfScorecardBySenior(null);
      setIsLoading(false);
    })();
  }, []);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await fetchSelfScorecardBySenior(filterData);
    setIsLoading(false);
    filterToggle();
  };


  useEffect(() => {
    const tableData = [
      "id",
      "site_id",
      "scheduled_date",
      "subject",
      "rating",
      "rating_remark",
      "rating_date",
      "rated_by"
    ];
    if (
        getUserScoreBySenior &&
        getUserScoreBySenior?.ratedMeetingsDetails &&
        getUserScoreBySenior?.ratedMeetingsDetails.data &&
        getUserScoreBySenior.ratedMeetingsDetails.data.length > 0
    ) {
      const data = getUserScoreBySenior.ratedMeetingsDetails.data.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
          }
        )
      );
      if (data) {
        setListData(data);
      } else {
        setListData([]);
      }

      setPageCount(
        Math.ceil(
            getUserScoreBySenior.ratedMeetingsDetails.total /
            getUserScoreBySenior.ratedMeetingsDetails.per_page
        )
      );
    }
  }, [getUserScoreBySenior]);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  console.log("date", getUserScoreBySenior.from_date)

  return (
    <Layout title={"Senior Scorecard"} isLoading={isLoading} Buttons={headerBtns} linkFlag>
    {getUserScoreBySenior ? (
        <div>
        <div className="panel-card">
            <div className="panel-heading">
                {getUserScoreBySenior && getUserScoreBySenior.from_date && getUserScoreBySenior.to_date ? (
                    `Scorecard (${getUserScoreBySenior.from_date} - ${getUserScoreBySenior.to_date})`
                ) : (
                    'Scorecard'
                )}
            </div>

            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={"Number Of Meetings Done"}
                  data={
                    getUserScoreBySenior?.totalMeetingDone
                      ? `${getUserScoreBySenior?.totalMeetingDone}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Number Of Meetings Rated"}
                  data={
                    getUserScoreBySenior?.totalMeetingRated
                      ? `${getUserScoreBySenior?.totalMeetingRated}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Average Score"}
                  data={
                    getUserScoreBySenior?.averageScore
                      ? `${getUserScoreBySenior?.averageScore}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Highest Performer"}
                  data={
                    getUserScoreBySenior?.highestPerformer
                      ? `${getUserScoreBySenior?.highestPerformer}`
                      : "N/A"
                  }
                />
              </div>
            </div>
        </div>
        <div className="panel-card">
            <div className="panel-heading">{`Rated Meetings`}</div>
                <div className="panel-body">
                    <TableSection
                        data={listData}
                        isId={false}
                        headers={Headers}
                        srNo={getUserScoreBySenior?.ratedMeetingsDetails?.from}
                    />
                </div>
            </div>
        </div>
      ) : (
        <div>
          <img src={Images?.NoData} alt="No Data Found" width="100%" />
        </div>
      )}
    <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        meetingRatingsFilter
        type={"SENIOR"}
        userFilter={false}
    />
    </Layout>
  );
};

export default ScoreBySenior;
